import type { ComponentType } from "react";

/** Band ikonkasi: lucide ham, oddiy SVG komponenti ham shu shaklga tushadi. */
export type NavIcon = ComponentType<{ className?: string }>;

/**
 * Yon panel bandining ko'rinish modeli.
 *
 * Admin paneli bilan kabinetning menyu sozlamasi har xil shaklda
 * (`labelKey`/`to` va `title`/`url`), tarjimasi ham boshqa kutubxonada.
 * Chizuvchi komponentlar (`NavFlyout`, `NavAccordion`) esa ikkala repoda bir
 * xil turadi — shuning uchun ular sozlamani emas, shu modelni oladi: yorliq
 * allaqachon tarjima qilingan, faollik allaqachon hisoblangan. Har bir ilova
 * o'z sozlamasini `toNavNode` bilan shu shaklga o'giradi.
 */
export interface NavNode {
  /** React kaliti — bir darajadagi bandlar orasida noyob. */
  key: string;
  /** Havola manzili. Bolalari bor bandda u havola emas, faqat nishon. */
  href: string;
  label: string;
  icon?: NavIcon;
  /** Joriy sahifa shu bandning o'zi yoki uning ichidagi biror band. */
  active: boolean;
  children?: NavNode[];
}

/**
 * Manzil shu bandga tegishlimi: `/courses` o'zining ichki sahifasida
 * (`/courses/7`) ham faol, lekin nomi o'xshash qo'shnisida
 * (`/courses-archive`) emas — shuning uchun oddiy `startsWith` yetmaydi.
 */
export const matchesPath = (pathname: string, path: string): boolean =>
  pathname === path || pathname.startsWith(`${path}/`);

/**
 * Ro'yxatda faol band bormi — istalgan chuqurlikda. Ota band shu bilan faol
 * bo'ladi: uchinchi qavatdagi sahifa ochiq bo'lsa ham, yon panelda uning
 * ikonkasi belgilangan turadi.
 */
export const hasActiveNode = (nodes: readonly NavNode[]): boolean =>
  nodes.some(node => node.active || (node.children ? hasActiveNode(node.children) : false));

/** Bolalari bor band havola emas — ochiluvchi guruh. */
export const isBranch = (node: NavNode): node is NavNode & { children: NavNode[] } =>
  !!node.children && node.children.length > 0;
